import styled from 'styled-components';
import Icon from '@minecraft.icon';

export const StyledClearButton = styled.div`
  display: flex;
  padding: 0.375rem 0.75rem;
`;

export const StyledClearIcon = styled(Icon)`
  cursor: pointer;
  height: 0.75rem;
  width: 0.75rem;
`;
